import { useState } from 'react';
import { Link } from '@trashlab/sitesapp/src/organizations/redebins/components/shared/link';
import { CaretDownIcon } from '@radix-ui/react-icons';
import { useTenantContext } from '@trashlab/sitesapp/src/organizations/redebins/contexts/use-tenant-context';

export const Nav = () => {
  const { website } = useTenantContext();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  
  // Desktop dropdown state
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  const handleMouseEnter = (dropdown: string) => {
    setActiveDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  // Close mobile menu when navigating
  const handleMobileNavClick = () => {
    setIsMobileMenuOpen(false);
    setIsServicesOpen(false);
    setIsResourcesOpen(false);
    setIsAboutOpen(false);
  };

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
                <Link href="/" className="flex items-center space-x-2">
            <img
              src="/redebins/images/Red-E-Bins_2026_RGB_Primary+Minnesota.svg"
              alt="Red-E-Bins Minnesota"
              className="h-14 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            {/* Services Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => handleMouseEnter('services')}
              onMouseLeave={handleMouseLeave}
            >
              <button className="flex items-center space-x-1 text-[#333333] hover:text-[#E31837] transition-colors py-2">
                <span>Services</span>
                <CaretDownIcon className="w-4 h-4" />
              </button>
              {activeDropdown === 'services' && (
                <div className="absolute top-full left-0 bg-white shadow-lg rounded-md py-2 min-w-[200px] z-50 border border-gray-100">
                  <Link
                    href="/residential"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    Residential
                  </Link>
                  <Link
                    href="/commercial"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    Commercial
                  </Link>
                  <Link
                    href="/junk-removal"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    Junk Removal
                  </Link>
                </div>
              )}
            </div>

            {/* Resources Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => handleMouseEnter('resources')}
              onMouseLeave={handleMouseLeave}
            >
              <button className="flex items-center space-x-1 text-[#333333] hover:text-[#E31837] transition-colors py-2">
                <span>Resources</span>
                <CaretDownIcon className="w-4 h-4" />
              </button>
              {activeDropdown === 'resources' && (
                <div className="absolute top-full left-0 bg-white shadow-lg rounded-md py-2 min-w-[200px] z-50 border border-gray-100">
                  <Link
                    href="/dumpster-sizes"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    Bin Sizes
                  </Link>
                  <Link
                    href="/dumpster-rental-guide"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    Helpful Tips
                  </Link>
                  <Link
                    href="/prohibited-items"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    {"Do's and Don'ts"}
                  </Link>
                  <Link
                    href="/how-we-measure-up"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    How We Measure Up
                  </Link>
                  <Link
                    href="/debris-calculator"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    Debris Calculator
                  </Link>
                </div>
              )}
            </div>

            {/* About Us Dropdown */}
            <div
              className="relative"
              onMouseEnter={() => handleMouseEnter('about')}
              onMouseLeave={handleMouseLeave}
            >
              <button className="flex items-center space-x-1 text-[#333333] hover:text-[#E31837] transition-colors py-2">
                <span>About Us</span>
                <CaretDownIcon className="w-4 h-4" />
              </button>
              {activeDropdown === 'about' && (
                <div className="absolute top-full left-0 bg-white shadow-lg rounded-md py-2 min-w-[200px] z-50 border border-gray-100">
                  <Link
                    href="/about-us"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    Nice To Meet You
                  </Link>
                  <Link
                    href="/service-areas"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    Service Areas
                  </Link>
                  <Link
                    href="/faq"
                    className="block px-4 py-2 text-[#333333] hover:text-[#E31837] hover:bg-gray-50"
                  >
                    FAQ
                  </Link>
                </div>
              )}
            </div>

            {/* Get In Touch */}
                  <Link
                    href="/contact"
                    className="text-[#333333] hover:text-[#E31837] transition-colors"
                  >
                    Get In Touch
                  </Link>

            {/* My Account - links to customer portal */}
            <a
              href={`https://app.trashlab.com/customer-portal/login?orgId=${website?.organization.id}`}
              className="text-[#333333] hover:text-[#E31837] transition-colors font-semibold"
            >
              My Account
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#333333]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 space-y-2">
            <div>
              <button
                className="w-full flex items-center justify-between text-[#333333] py-2"
                onClick={() => setIsServicesOpen(!isServicesOpen)}
              >
                <span>Services</span>
                <CaretDownIcon className="w-4 h-4" />
              </button>
              {isServicesOpen && (
                <div className="pl-4 space-y-2">
                         <Link href="/residential" className="block py-2 text-[#333333]" onClick={handleMobileNavClick}>
                           Residential
                         </Link>
                         <Link href="/commercial" className="block py-2 text-[#333333]" onClick={handleMobileNavClick}>
                           Commercial
                         </Link>
                         <Link href="/junk-removal" className="block py-2 text-[#333333]" onClick={handleMobileNavClick}>
                           Junk Removal
                         </Link>
                </div>
              )}
            </div>
            <div>
              <button
                className="w-full flex items-center justify-between text-[#333333] py-2"
                onClick={() => setIsResourcesOpen(!isResourcesOpen)}
              >
                <span>Resources</span>
                <CaretDownIcon className="w-4 h-4" />
              </button>
              {isResourcesOpen && (
                <div className="pl-4 space-y-2">
                  <Link href="/dumpster-sizes" className="block py-2 text-[#333333]" onClick={handleMobileNavClick}>
                    Bin Sizes
                  </Link>
                  <Link
                    href="/dumpster-rental-guide"
                    className="block py-2 text-[#333333]"
                    onClick={handleMobileNavClick}
                  >
                    Helpful Tips
                  </Link>
                  <Link href="/prohibited-items" className="block py-2 text-[#333333]" onClick={handleMobileNavClick}>
                    {"Do's and Don'ts"}
                  </Link>
                  <Link
                    href="/how-we-measure-up"
                    className="block py-2 text-[#333333]"
                    onClick={handleMobileNavClick}
                  >
                    How We Measure Up
                  </Link>
                  <Link
                    href="/debris-calculator"
                    className="block py-2 text-[#333333]"
                    onClick={handleMobileNavClick}
                  >
                    Debris Calculator
                  </Link>
                </div>
              )}
            </div>
            <div>
              <button
                className="w-full flex items-center justify-between text-[#333333] py-2"
                onClick={() => setIsAboutOpen(!isAboutOpen)}
              >
                <span>About Us</span>
                <CaretDownIcon className="w-4 h-4" />
              </button>
              {isAboutOpen && (
                <div className="pl-4 space-y-2">
                  <Link href="/about-us" className="block py-2 text-[#333333]" onClick={handleMobileNavClick}>
                    Nice To Meet You
                  </Link>
                  <Link href="/service-areas" className="block py-2 text-[#333333]" onClick={handleMobileNavClick}>
                    Service Areas
                  </Link>
                  <Link href="/faq" className="block py-2 text-[#333333]" onClick={handleMobileNavClick}>
                    FAQ
                  </Link>
                </div>
              )}
            </div>
            <Link href="/contact" className="block py-2 text-[#333333]" onClick={handleMobileNavClick}>
              Get In Touch
            </Link>
            <a 
              href={`https://app.trashlab.com/customer-portal/login?orgId=${website?.organization.id}`}
              className="block py-2 text-[#333333] font-semibold"
              onClick={handleMobileNavClick}
            >
              My Account
            </a>
          </div>
        )}
      </nav>
    </header>
  );
};
